import * as React from "react";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import { LtlFreightItemNmfcDescriptionRow } from "./LtlFreightItemNmfcDescriptionRow";
import { LtlFreightItemPrimaryRow } from "./LtlFreightItemPrimaryRow";

type ItemRow = LTLState["items"][number];

interface LtlFreightItemCoreFieldsProps {
  item: ItemRow;
  index: number;
  state: LTLState;
  showNmfc: boolean;
  nmfcRequired: boolean;
  onItemFieldChange: (index: number, field: keyof ItemRow, value: unknown) => void;
  onFieldBlur?: () => void;
  getTextFieldStyles: (fieldKey: string) => unknown;
  maxWeight?: number;
}

export function LtlFreightItemCoreFields({
  item,
  index,
  state,
  showNmfc,
  nmfcRequired,
  onItemFieldChange,
  onFieldBlur,
  getTextFieldStyles,
  maxWeight,
}: LtlFreightItemCoreFieldsProps): React.ReactElement {
  return (
    <>
      <LtlFreightItemPrimaryRow
        item={item}
        index={index}
        state={state}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
        maxWeight={maxWeight}
      />
      <LtlFreightItemNmfcDescriptionRow
        item={item}
        index={index}
        state={state}
        showNmfc={showNmfc}
        nmfcRequired={nmfcRequired}
        onItemFieldChange={onItemFieldChange}
        onFieldBlur={onFieldBlur}
        getTextFieldStyles={getTextFieldStyles}
      />
    </>
  );
}
